import { render, staticRenderFns } from "./u-tit-default.vue?vue&type=template&id=35085727&scoped=true"
import script from "./u-tit-default.vue?vue&type=script&lang=js"
export * from "./u-tit-default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35085727",
  null
  
)

export default component.exports